const readOnlyFieldStyle = () => ({
  wrapper: {
		margin: '15px 0',
		letterSpacing: 0,
		lineHeight: '21px',
		fontWeight: 400,
  },
	label: {
		color: 	'#808080',
		fontSize: '11px',
  },
  value: {
		color: 	'#1A1A1A',
		fontSize: '14px',
  }

});

export default readOnlyFieldStyle;
